module.exports = __webpack_public_path__ + "img/letter-spacing-01.f202f431.svg";